import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { dataLayerPush } from '@r1-frontend/analytics/dataLayerPush';

import Button from '@r1-frontend/ui-react/components/buttons/button';
import { ButtonGroup } from '@r1-frontend/ui-react/components/buttons/buttonGroup/ButtonGroup';
import { H3 } from '@r1-frontend/ui-react/components/typography/heading';
import { Paragraph4 } from '@r1-frontend/ui-react/components/typography/paragraph';
import { FullWidthListContainer } from '@r1-frontend/ui-react/experimental/containers';
import { CATEGORIES, EVENTS } from '@r1-frontend/shared/constants/analytics';

import { TState } from '~/src/store';
import { openChat } from '~/src/store/actions/chat';
import selectCallCenterNumber from '~/src/store/selectors/selectCallCenterNumber';

import * as ST from './styled';

const CallbackContacts = (): JSX.Element => {
    const dispatch = useDispatch();

    const {
        callCenter,
        callCenterNumber,
    } = useSelector((state: TState) => ({
        callCenter: state.city.currentCity.callCenter,
        callCenterNumber: selectCallCenterNumber(state),
    }));

    const href = `tel:+${callCenterNumber}`;

    const callTouchHandler = () => {
        dataLayerPush({
            event: EVENTS.UAevent,
            category: CATEGORIES.fullBuy,
            action: 'click calltouch',
        });
    };

    const openChatHandler = () => {
        dataLayerPush({
            event: EVENTS.UAevent,
            category: CATEGORIES.fullBuy,
            action: 'click chat',
        });

        dispatch(openChat());
    };

    return (
        <ST.SBlockContainer rounder={{ $radius: 32 }} indent={{ $united: [24] }}>
            <FullWidthListContainer $size={8} $direction={'column'} $wrap={'nowrap'}>
                <H3 $withIndent={false}>Если остались вопросы</H3>
                <Paragraph4>
                    Позвоните в поддержку&nbsp;
                    <ST.Phone
                        href={href}
                        className='js-calltouch-phone'
                        data-test='callCenterLink'
                        onClick={callTouchHandler}
                    >
                        {callCenter}
                    </ST.Phone>. Мы всегда на связи.
                </Paragraph4>
            </FullWidthListContainer>
            <ButtonGroup>
                <Button
                    bType={'secondary'}
                    onClick={openChatHandler}
                    data-test='chat-btn'
                >
                    Написать в поддержку
                </Button>
            </ButtonGroup>
        </ST.SBlockContainer>
    );
};

export default CallbackContacts;
